import styled from "styled-components";

export const StyledAddress = styled.div`
  font-size: 13px;
  line-height: 16px;
`;

export const StyledSpecialInstructions = styled.div`
  margin-top: 16px;
  font-style: italic;
`;
